import React from "react";
import { AppBar, Toolbar, IconButton, Tooltip, Slider, Box, Button, Divider, Typography, Autocomplete, TextField } from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SaveIcon from "@mui/icons-material/Save";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PrintIcon from "@mui/icons-material/Print";

const TopToolbar = ({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  zoom,
  onZoomChange,
  previewMode,
  onTogglePreview,
  products,
  previewProductId,
  onPreviewProductChange,
  onSave,
  onExportPdf,
  onPrint,
  saving,
}) => (
  <AppBar position="static" color="inherit" elevation={0} sx={{ borderBottom: "1px solid #eee" }}>
    <Toolbar variant="dense" sx={{ gap: 1 }}>
      <Tooltip title="Undo">
        <span>
          <IconButton size="small" disabled={!canUndo} onClick={onUndo}>
            <UndoIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Redo">
        <span>
          <IconButton size="small" disabled={!canRedo} onClick={onRedo}>
            <RedoIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <ZoomInIcon fontSize="small" />
      <Slider
        size="small"
        min={0.5}
        max={3}
        step={0.1}
        value={zoom}
        onChange={(e, v) => onZoomChange(v)}
        sx={{ width: 120 }}
      />
      <Typography variant="caption">{Math.round(zoom * 100)}%</Typography>

      <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

      <Button
        size="small"
        startIcon={<VisibilityIcon />}
        variant={previewMode ? "contained" : "outlined"}
        onClick={onTogglePreview}
      >
        Preview
      </Button>

      {previewMode && (
        <Autocomplete
          size="small"
          options={products || []}
          value={products?.find((p) => p.id === previewProductId) || null}
          getOptionLabel={(p) => (p ? `${p.productNameEn || ""}${p.sku ? ` (${p.sku})` : ""}` : "")}
          isOptionEqualToValue={(a, b) => a.id === b.id}
          onChange={(e, value) => onPreviewProductChange?.(value ? value.id : "")}
          sx={{ width: 220 }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Preview with product..." variant="outlined" />
          )}
        />
      )}

      <Box sx={{ flexGrow: 1 }} />

      <Button size="small" variant="outlined" startIcon={<PictureAsPdfIcon />} onClick={onExportPdf}>
        Export PDF
      </Button>
      <Button size="small" variant="outlined" startIcon={<PrintIcon />} onClick={onPrint}>
        Print
      </Button>
      <Button size="small" variant="contained" startIcon={<SaveIcon />} disabled={saving} onClick={onSave}>
        {saving ? "Saving..." : "Save"}
      </Button>
    </Toolbar>
  </AppBar>
);

export default TopToolbar;
